export const serviceAreas = [
  "Los Angeles",
  "San Diego",
  "San Francisco",
  "Sacramento",
  "Orange County",
  "Riverside",
  "San Bernardino",
  "Ventura County",
  "Santa Barbara",
  "Bakersfield",
  "Fresno",
  "Long Beach",
  "Anaheim",
  "Santa Ana",
  "Irvine",
  "Pasadena",
  "Burbank",
  "Glendale",
  "Torrance",
  "Santa Monica",
  "Beverly Hills",
  "Malibu",
  "Calabasas",
  "Thousand Oaks",
  "Simi Valley",
  "Oxnard",
  "Ventura",
  "Oceanside",
  "Escondido",
  "Carlsbad",
];